import { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { MEASUREMENT_TYPES } from "../../../../../../config/enums/MeasurementTypes";
import { PACKAGING_DEFAULT_CLICKED_UNIT } from "../packagingLevel.config";

export const usePackagingNameForm = (packagingName?: string) => {
  const values = useMemo(
    () => ({
      packagingName
    }),
    [packagingName]
  );

  const form = useForm({
    mode: "all",
    defaultValues: values,
    values: values
  });

  const hasSavedName = !!packagingName?.trim();
  const [nameExpanded, setNameExpanded] = useState(true);
  const [isNameEditMode, setIsNameEditMode] = useState(false);
  const isNameLocked = hasSavedName && !isNameEditMode;

  useEffect(() => {
    if (hasSavedName) {
      setNameExpanded(false);
      setIsNameEditMode(false);
    } else {
      setNameExpanded(true);
    }
  }, [hasSavedName]);

  const startNameEdit = useCallback(() => {
    setIsNameEditMode(true);
    setNameExpanded(true);
  }, []);

  const finishNameSave = useCallback(() => {
    setIsNameEditMode(false);
    setNameExpanded(false);
  }, []);

  return {
    form,
    hasSavedName,
    nameExpanded,
    setNameExpanded,
    isNameEditMode,
    isNameLocked,
    startNameEdit,
    finishNameSave
  };
};

export const usePackagingUnitState = () => {
  const [isSaveBtnClicked, setIsSaveBtnClicked] = useState(false);
  const [clickedPackagingUnit, setClickedPackagingUnit] = useState(PACKAGING_DEFAULT_CLICKED_UNIT);
  const [unitSizeWeightUnit, setUnitSizeWeightUnit] = useState(MEASUREMENT_TYPES.WEIGHT_KG);

  return {
    isSaveBtnClicked,
    setIsSaveBtnClicked,
    clickedPackagingUnit,
    setClickedPackagingUnit,
    unitSizeWeightUnit,
    setUnitSizeWeightUnit
  };
};

export const useUnitSizeWeightUnitSync = (
  apiUnitSizeWeightUnit: MEASUREMENT_TYPES | undefined,
  setUnitSizeWeightUnit: (value: MEASUREMENT_TYPES) => void
) => {
  useEffect(() => {
    if (apiUnitSizeWeightUnit != null) {
      setUnitSizeWeightUnit(apiUnitSizeWeightUnit);
    }
  }, [apiUnitSizeWeightUnit, setUnitSizeWeightUnit]);
};

export const usePackagingIdRefetch = (
  packagingId: string | null | undefined,
  refetch: (...args: any[]) => unknown
) => {
  useEffect(() => {
    if (packagingId) {
      refetch(packagingId);
    }
  }, [packagingId, refetch]);
};

export const useExistingPackagingName = (
  status: string,
  packagingName?: string
) => {
  return useMemo(() => {
    if (status === "success") {
      return packagingName ?? "";
    }
    return "";
  }, [status, packagingName]);
};
